import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { LocalizationModule } from './localization/localization.module';
import { CommonModule } from '@angular/common';
import { UtilsModule } from './utils/utils.module';
import { McbFormsModule } from './forms/forms.module';


@NgModule({
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,

    McbFormsModule,
    UtilsModule,
    LocalizationModule,
  ]
})
export class CommonInfrastructureModule {
}
